import scrollTo from '../helpers/scroll-to';

const $ = window.jQuery;

function scrollToAnchor(anchor) {
    const element =
        document.querySelector(`[name='${anchor}']`) ||
        document.querySelector(`#${anchor}`) ||
        null;

    if (element) {
        const positionY = $(element).offset().top - 150;

        scrollTo(positionY, 300);
    }
}

$(document).ready(() => {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
        anchor.addEventListener('click', function handleEvent(e) {
            e.preventDefault();

            scrollToAnchor(this.getAttribute('href').substring(1));
        });
    });

    if (window.location.hash) {
        scrollToAnchor(window.location.hash.replace(/^#/, ''));
    }
});
